import { apiClient } from "./client";

export type NotificationCode = "N1" | "N2" | "N3" | "N4" | "N5" | "N6" | "N7" | "N8";

export interface NotificationSetting {
  code: NotificationCode;
  is_enabled: boolean;
  params: Record<string, unknown>;
}

export interface NotificationLogEntry {
  id: string;
  ts: string;
  code: NotificationCode;
  sent: number;
  failed: number;
  skipped: number;
  is_enabled: boolean;
  payload: Record<string, unknown> | null;
}

export interface NotificationLogFilter {
  code?: NotificationCode;
  limit?: number;
  offset?: number;
}

export const notificationsApi = {
  list: () =>
    apiClient.get<NotificationSetting[]>("/notifications/settings").then((r) => r.data),

  upsert: (items: NotificationSetting[]) =>
    apiClient
      .put<NotificationSetting[]>("/notifications/settings", { items })
      .then((r) => r.data),

  log: (params: NotificationLogFilter = {}) =>
    apiClient
      .get<NotificationLogEntry[]>("/notifications/log", { params })
      .then((r) => r.data),
};
